<template>
<div>
  <div class="mb-4">
    <!-- tablet & above -->
    <div v-show="!edit && !isSmallScreen()">
      <div class="flex mx-auto text-lg">
        <div class="w-4/12 ml-0 font-bold text-right lg:ml-6">
          <h3>{{ title }}</h3>
        </div>
        <div class="w-5/12 ml-6 lg:w-4/12 lg:pr-4 ">
          <p class="break-words" :class="{ 'text-polred' : !complete && required }">
            {{ showErrorMessageForBT() }}
          </p>
        </div>
        <a @click="confirmEdit()" @keypress.enter.prevent="$event.target.click" tabindex="0">
          <button v-if="!hideEdit" tabindex="0" type="button" class="text-polred float-right w-auto underline outline-none btn-edit">
            {{ editButtonText }}
          </button>
        </a>
      </div>
    </div>
    <!-- mobile -->
    <div v-show="!edit && isSmallScreen()">
      <div class="flex mx-auto text-lg">
        <div class="w-10/12 ml-4 lg:ml-6">
          <h3 class="mt-2 text-lg font-semibold">{{ title }}</h3>
          <p class="text-lg" :class="{ 'text-polred' : !complete && required, }">{{ showErrorMessageForBT() }}</p>
        </div>
        <div class="mt-8">
          <button tabindex="0" v-if="!hideEdit" @keypress.enter.prevent="$event.target.click" type="button" @click="confirmEdit()" class="text-polred float-right w-auto text-lg underline outline-none text-bold">
            {{ editButtonText }}
          </button>
        </div>
      </div>
    </div>
    <!-- Edit Confirm Modal -->
    <div aria-labelledby="modalTitle" aria-describedby="modalDescription" role="dialog" :aria-modal="true" :aria-hidden="confirmModalShowing ? 'false' : 'true'" v-if="confirmModalShowing" class="h-screen overlay-bg fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center z-50">
      <div class="mb-4 mx-4 fixed inset-x-0 bottom-0 md:mb-0 md:mx-0 md:relative px-4 md:px-16 py-10 text-center bg-white shadow-popup rounded-full-large lg:px-32 md:py-16">
        <div class="mb-4">
          <h2 id="modalTitle" class="text-3xl font-bold leading-tight lg:text-4xl"> Are you sure you want to make a change?</h2>
        </div>
        <h3 id="modalDescription" class="text-xl">Changing your details could affect your eligibility for this credit card.</h3>
        <div class="w-full mt-6 text-lg font-bold">
          <button id="modalNoButton" aria-label="No" ref="modalStart" type="button" @keypress.enter.prevent="$event.target.click" tabindex="0" @click="confirmModalShowing = !confirmModalShowing" class="outline-none w-3/12 py-2 mx-4 my-2 border rounded-full lg:w-4/12 hover:bg-polgrey border-polgrey-dark">No</button>
          <button aria-label="Yes, continue" type="button" @keypress.enter.prevent="$event.target.click" tabindex="0" @click="confirmed()" class="outline-none w-4/12 w-6/12 py-2 mx-4 my-2 text-white border rounded-full lg:w-4/12 hover:bg-polred-dark border-polred bg-polred">Yes, continue</button>
        </div>
      </div>
    </div>
    <div v-show="edit" class="relative px-2 md:px-8 py-8 mb-10 border-t border-b border-polgrey-medium">
      <div class="w-10/12 mx-auto">
        <!-- injected fields -->
        <slot/>
      </div>
      <div class="mt-4 text-center md:text-right lg:mt-2" v-if="!hideButton">
        <a tabindex="0" @click="edit = !edit" @keypress.enter.prevent="$event.target.click">
          <button type="button" class="w-10/12 px-4 py-2 mt-4 font-semibold text-white bg-white rounded-full shadow-xs md:w-2/12 bg-polred hover:bg-polred-dark">
            Complete
          </button>
        </a>
      </div>
    </div>
  </div>
  </div>
</template>

<script>

import mixins from '@/v2/mixins'

export default {
  name: 'AggregatorEditRow',
  mixins: [mixins],
  props: {
    title: String,
    preview: String,
    complete: Boolean,
    hideEdit: Boolean,
    hideButton: Boolean,
    creditTypeFlag: String,
    required: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    // close all other edit fields that have been opened
    this.$root.$on('closeEditFields', this.resetView)
  },
  computed: {
    editButtonText: function() {
      return this.complete ? 'Edit' : 'Add'
    }
  },
  methods: {
    resetView() {
      this.confirmModalShowing = false
      this.edit = false
    },
    confirmEdit() {

      // we should only show the edit modal when we have data
      // prepopulated otherwise it's pointless given their isn't any data.
      if (!this.complete) {
        this.confirmed()
        return
      }
      
      this.confirmModalShowing = true
    },
    confirmed() {
      this.$root.$emit('closeEditFields')
      this.confirmModalShowing = false
      this.edit = true
    },
    showErrorMessageForBT(){
      if(this.complete){
        if(this.isSmallScreen()){
          return this.truncate(this.preview, this.truncateDefault)
        }
        return this.preview
      }else{
        if(this.required && this.creditTypeFlag){
          return "Balance Transfer amount should be a minimum of £50"
        }else if (this.required){
          return "Required"
        }else{
          return ""
        }
      }
    },
  },
  data() {
    return {
      edit: false,
      truncateDefault: 40,
      confirmModalShowing: false,
    }
  }
}
</script>